export const ROUTE_PATHS = {
  HOME: '/',
  FORMATION_B2C: '/formation-b2c',
  FORMATION_B2B: '/formation-b2b',
  CONFIDENTIALITE: '/confidentialite',
  MENTIONS_LEGALES: '/mentions-legales',
  COOKIES: '/cookies'
} as const;

export interface Profile {
  id: string;
  number: string;
  title: string;
  description: string;
}

export interface Capsule {
  id: string;
  number: string;
  title: string;
  description: string;
}

export const PROFILES: Profile[] = [
  {
    id: 'reconversion',
    number: '01',
    title: 'Reconversion',
    description: "Tu changes de cap. Nouveau métier, nouveau marché. Tu dois repositionner ton identité pro et apprendre à vendre ce que tu n'as pas encore le CV pour prouver."
  },
  {
    id: 'independant',
    number: '02',
    title: 'Indépendant·e',
    description: "L'activité existe. Mais tu peines à conclure, tu sous-factures. La méthode t'apprend à signer sans forcer."
  },
  {
    id: 'atypique',
    number: '03',
    title: 'Profil atypique',
    description: "Ton parcours ne rentre dans aucune case. C'est exactement ce qui peut devenir ton positionnement le plus puissant."
  },
  {
    id: 'pret',
    number: '04',
    title: 'Prêt·e à agir',
    description: "Pas dans six mois. Si tu cherches une raison d'attendre, ce programme n'est pas pour toi."
  }
];

export const CAPSULES: Capsule[] = [
  {
    id: 'identite',
    number: '01',
    title: 'Identité & Positionnement',
    description: 'Construis une identité professionnelle claire et un positionnement qui te différencie.'
  },
  {
    id: 'closing',
    number: '02',
    title: 'Méthode de closing',
    description: 'Maîtrise les techniques de vente et de closing adaptées à ton activité.'
  },
  {
    id: 'structurer',
    number: '03',
    title: 'Structurer ton activité',
    description: 'Organise ton activité pour la rendre pérenne et scalable.'
  }
];

export const CONTACT = {
  email: 'camille@camillevega.com',
  phone: '06 95 77 11 67',
  linkedin: 'https://www.linkedin.com/in/camille-vega-de-hoyos-a8366224b/',
  instagram: 'https://www.instagram.com/camille_vegadehoyos/',
  ctaForm: 'https://api.whatsapp.com/send/?phone=33695771167&text=Bonjour+Camille%2C+j%27ai+découvert+ton+site+et+je+voudrais+qu%27on+échange+de+vive+voix.+Quelles+sont+tes+disponibilités+pour+un+appel+%3F&type=phone_number&app_absent=0'
} as const;

export const TIMELINE = [
  {
    id: 'militaire',
    period: 'Avant',
    title: 'Militaire',
    description: 'Rigueur, résistance, tenir debout quand tout vacille.'
  },
  {
    id: 'ouvriere',
    period: 'Ensuite',
    title: 'Ouvrière',
    description: 'La valeur du travail concret, sans filet.'
  },
  {
    id: 'commerciale',
    period: 'Puis',
    title: 'Commerciale',
    description: 'La vente réelle — objections, NON répétés, clients difficiles.'
  },
  {
    id: 'entrepreneuse',
    period: "Aujourd'hui",
    title: 'Entrepreneuse & Formatrice',
    description: 'Je transmets ce vécu pour que tu trouves ta place.'
  }
] as const;

export const CONSTAT_POINTS = [
  {
    id: 'deconnectees',
    number: '01',
    title: 'Des formations déconnectées du terrain',
    description: 'Slides soignées, concepts séduisants — mais aucun outil concret pour conclure une vente ou décrocher un premier client.'
  },
  {
    id: 'mal-enseignee',
    number: '02',
    title: 'La vente, mal enseignée',
    description: "On confond technique et manipulation. Vendre correctement, c'est aligner ce que tu proposes avec ce que l'autre a vraiment besoin."
  },
  {
    id: 'profil-atypique',
    number: '03',
    title: 'Le profil atypique, laissé pour compte',
    description: 'Les parcours non-linéaires ne trouvent pas leur place dans les formations standard.'
  }
] as const;

export const FORMATION_TYPES = [
  {
    id: 'en-ligne',
    title: 'Formation en ligne',
    features: [
      'Capsules vidéo et exercices pratiques',
      'Méthode de closing appliquée',
      'Repositionnement et identité pro',
      'Outils de vente et scripts adaptés',
      'Accès à vie au contenu'
    ]
  },
  {
    id: 'coaching',
    title: 'Coaching 1-1',
    features: [
      'Sessions individuelles en visio',
      'Diagnostic et plan d\'action sur-mesure',
      'Suivi entre les séances',
      'Retours directs sur tes pitchs',
      'Nombre de séances selon formule'
    ]
  }
] as const;

export const CTA_STEPS = [
  {
    id: 'reserver',
    number: '01',
    title: 'Tu réserves un appel',
    description: 'Un créneau de 30 minutes avec Camille, sans engagement.'
  },
  {
    id: 'point',
    number: '02',
    title: 'On fait le point ensemble',
    description: 'Ta situation, tes objectifs, tes blocages.'
  },
  {
    id: 'clarte',
    number: '03',
    title: 'Tu repars avec de la clarté',
    description: 'Que tu rejoignes le programme ou non.'
  }
] as const;

export const MARQUEE_ITEMS = [
  'Vendre sans se trahir',
  'Assumer sa valeur',
  'Closing stratégique',
  'Parcours atypique',
  '100% en ligne',
  'Coaching 1-1'
] as const;
